import {RestService} from './_rest.service'
import {REST_API_END_POINTS} from './constants'
import {LoanerItem} from "../api";

export class LoanerInventoryService extends RestService<LoanerItem> {
    constructor(url: string) {
        if (!url) {
            super(REST_API_END_POINTS.LOANER_INVENTORY)
        } else {
            super(url)
        }
    }

    assignment_log() {
        return this.instance.get(`${this.url}assignment_log/`)
    }

    unblock() {
        return this.instance.post(`${this.url}unblock/`)
    }

    cancel() {
        return this.instance.post(`${this.url}cancel/`)
    }
}
